import {LOAD_WORK_ORDER_SUCCESS} from "../actions/dispatchTypes";

export default function locationReducer(state = null, action) {
    switch (action.type) {
        case LOAD_WORK_ORDER_SUCCESS:
            return action.payload.location || state;
        default:
            return state;
    }
}